import React from 'react';
import { useT } from '../lib/i18n';
import { useAuth } from '../contexts/AuthContext';
import { LifeBuoy, Mail, Bug } from 'lucide-react';

const SUPPORT_EMAIL = 'support@soumissionpro.net';

export function ContactCard() {
  const { lang } = useT();
  const { user } = useAuth();

  const sendEmail = () => {
    const date = new Date().toLocaleDateString(lang === 'fr' ? 'fr-CA' : 'en-CA');
    const subject = lang === 'fr'
      ? 'Demande de support — SoumissionPro'
      : 'Support request — SoumissionPro';
    const body = lang === 'fr'
      ? `Bonjour,

J'aimerais obtenir de l'aide concernant SoumissionPro.

Objet de ma demande :
(Décrivez en quelques mots ce dont vous avez besoin)


Détails complémentaires :
(Ajoutez ici toute information utile, captures d'écran, exemples…)


Merci à l'avance pour votre réponse.


─────────────────────────
Compte    : ${user?.email || ''}
Date      : ${date}
Envoyé depuis SoumissionPro
─────────────────────────`
      : `Hello,

I'd like to get some help with SoumissionPro.

What I need help with:
(Briefly describe what you need)


Additional details:
(Add any useful information, screenshots, examples…)


Thank you in advance for your reply.


─────────────────────────
Account   : ${user?.email || ''}
Date      : ${date}
Sent from SoumissionPro
─────────────────────────`;
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const reportBug = () => {
    const ua = (navigator.userAgent || '').slice(0, 120);
    const date = new Date().toLocaleDateString(lang === 'fr' ? 'fr-CA' : 'en-CA');
    const subject = lang === 'fr'
      ? 'Signalement d\'un problème — SoumissionPro'
      : 'Issue report — SoumissionPro';
    const body = lang === 'fr'
      ? `Bonjour,

Je souhaite signaler un problème rencontré dans SoumissionPro.

──  DESCRIPTION DU PROBLÈME  ──
(Que s'est-il passé ?)


──  PAGE OU SECTION CONCERNÉE  ──
(Ex. : Nouvelle soumission, Profil, Signature, etc.)


──  ÉTAPES POUR REPRODUIRE  ──
1. 
2. 
3. 


──  RÉSULTAT ATTENDU  ──
(Que devrait-il se passer normalement ?)


──  COMMENTAIRES ADDITIONNELS  ──
(Captures d'écran, fréquence, contexte particulier…)


Merci de votre attention.


─────────────────────────
Compte    : ${user?.email || ''}
Date      : ${date}
Appareil  : ${ua}
─────────────────────────`
      : `Hello,

I'd like to report an issue in SoumissionPro.

──  ISSUE DESCRIPTION  ──
(What happened?)


──  PAGE OR SECTION AFFECTED  ──
(e.g. New submission, Profile, Signature…)


──  STEPS TO REPRODUCE  ──
1. 
2. 
3. 


──  EXPECTED BEHAVIOUR  ──
(What should normally happen?)


──  ADDITIONAL NOTES  ──
(Screenshots, frequency, special context…)


Thank you for looking into this.


─────────────────────────
Account   : ${user?.email || ''}
Date      : ${date}
Device    : ${ua}
─────────────────────────`;
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div data-testid="contact-card" className="card p-4">
      <div className="flex items-start gap-3 mb-3">
        <div className="w-10 h-10 rounded-xl bg-[#7A1F2B] text-white flex items-center justify-center shrink-0">
          <LifeBuoy size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-heading font-black text-base text-[#7A1F2B]">
            {lang === 'fr' ? 'Besoin d\'aide ?' : 'Need help?'}
          </div>
          <div className="text-xs text-gray-600 mt-1 leading-relaxed">
            {lang === 'fr'
              ? 'Notre équipe répond en moins de 24 h ouvrables.'
              : 'Our team replies within 24 business hours.'}
          </div>
          <div className="text-[11px] text-gray-500 mt-1 font-mono">
            {SUPPORT_EMAIL}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          data-testid="contact-email-btn"
          onClick={sendEmail}
          className="btn-outline gap-2 !min-h-[44px] !text-xs"
        >
          <Mail size={14} />
          {lang === 'fr' ? 'Envoyer un courriel' : 'Send an email'}
        </button>
        <button
          type="button"
          data-testid="report-bug-btn"
          onClick={reportBug}
          className="btn-outline gap-2 !min-h-[44px] !text-xs"
        >
          <Bug size={14} />
          {lang === 'fr' ? 'Signaler un bug' : 'Report a bug'}
        </button>
      </div>
    </div>
  );
}
